import EscalationService from 'src/modules/escalation/escalationService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'ESCALATION_FORM';

const escalationFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: escalationFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EscalationService.find(id);
      }

      dispatch({
        type: escalationFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: escalationFormActions.INIT_ERROR,
      });

      getHistory().push('/escalation');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: escalationFormActions.CREATE_STARTED,
      });

      await EscalationService.create(values);

      dispatch({
        type: escalationFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.escalation.create.success'),
      );

      getHistory().push('/escalation');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: escalationFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: escalationFormActions.UPDATE_STARTED,
      });

      await EscalationService.update(id, values);

      dispatch({
        type: escalationFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.escalation.update.success'),
      );

      getHistory().push('/escalation');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: escalationFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default escalationFormActions;
